import * as CONST from "actions/action_constants";

export const requestProjects = username => ({
  type: CONST.PROJECT_BROWSER_REQUEST,
  username
});

export const kiosksFetchRequest = username => ({
  type: CONST.INSTALLATIONS_FETCH_REQUEST,
  username
});

export const installationFetchRequest = (installationID, filters) => ({
  type: CONST.INSTALLATION_FETCH_REQUEST,
  installationID,
  filters: filters
});

export const installationCreateRequest = inputData => ({
  type: CONST.INSTALLATION_CREATE_REQUEST,
  inputData
});

export const installationPublishRequest = installationID => ({
  type: CONST.INSTALLATION_PUBLISH_REQUEST,
  installationID
});

export const createInstallationRevertCopy = installationID => ({
  type: CONST.INSTALLATION_CREATE_REVERT_COPY,
  installationID
});

export const revertInstallationChanges = () => ({
  type: CONST.INSTALLATION_REVERT_CHANGES
});

// Used to update Installation settings
export const setInstallationProp = (installationID, prop, value) => ({
  type: CONST.INSTALLATION_PROP_CHANGE,
  installationID,
  prop,
  value
});

export const installationUpdateRequest = (installationID, saveType) => ({
  type: CONST.INSTALLATION_UPDATE_REQUEST,
  installationID,
  saveType
});

export const installationUpdateHistoryEntry = (installationID, publishID, stage, status, metadata) => ({
  type: CONST.INSTALLATION_UPDATE_HISTORY_ENTRY,
  installationID,
  publishID,
  stage,
  status,
  metadata
});

export const installationRevertRequest = (installationID, bundleID) => ({
  type: CONST.INSTALLATION_REVERT_REQUEST,
  installationID,
  bundleID
});

export const kioskAppVersionsFetchRequest = () => ({
  type: CONST.KIOSK_APP_VERSIONS_FETCH_REQUEST
});
